import React from 'react';
import { Spin } from 'antd';

function Loading(props) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
            <Spin size="large" />
        </div>
    );
}

export default Loading;